<template>
    <div class="main">
        <div class="grid-container">
            <div class="grid-x">
                <div class="small-12 cell">
                    <h1>Sneaker stats</h1>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'stats',
    data () {
        return {
        }
    },
    methods: {
    }
}
</script>



// WEBPACK FOOTER //
// Stats.vue?5b45fa3e